import {ga} from "./directives";
import {GoogleAnalytics} from "./vendors";

export default function install(Vue, options = {}) {
    Vue.directive("ga", ga);
    Vue.prototype.$ga = GoogleAnalytics;
}
